import React from 'react'

const Testimonial = () => {
    return (
        <section className="testimonials-area pt-100 bg-f1f8fb">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title"><img src="assets/img/star-icon.png" alt="image" /> Testimonials</span>
                    <h2>What Our Clients are Saying?<span className="overlay-1"></span></h2>
                    <p>See what our customer's testimony.</p>
                </div>

                <div className="testimonials-slides owl-carousel owl-theme">
                    <div className="single-testimonials-item">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ali. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        <div className="client-info">
                            <div className="d-flex justify-content-center align-items-center">
                                <img src="assets/img/testimonials/img1.jpg" alt="image" />
                                <div className="title">
                                    <h3>Alex Maxwell</h3>
                                    <span>CEO at EnvyTheme</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-testimonials-item">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ali. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        <div className="client-info">
                            <div className="d-flex justify-content-center align-items-center">
                                <img src="assets/img/testimonials/img2.jpg" alt="image" />
                                <div className="title">
                                    <h3>David Warner</h3>
                                    <span>CEO at Envato</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-testimonials-item">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ali. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        <div className="client-info">
                            <div className="d-flex justify-content-center align-items-center">
                                <img src="assets/img/testimonials/img3.jpg" alt="image" />
                                <div className="title">
                                    <h3>Sarah Taylor</h3>
                                    <span>CEO at ThemeForest</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="testimonials-view-btn text-center">
                    <a href="testimonials.html" className="default-btn"><i className="flaticon-view"></i>Check Out All Reviews<span></span></a>
                </div>
            </div>

            <div className="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"/></div>
        </section>
    )
}

export default Testimonial
